const cards = [
  {
    tag: 'Coming soon',
    title: 'Meeting summary notes',
    body: 'After the call ends, Jessica delivers a clean written summary of what was discussed, decided, and assigned — directly to your inbox. No app to open. No transcript to skim.',
    note: null,
  },
  {
    tag: 'Coming soon',
    title: 'Full meeting recording',
    body: "Because Jessica joined the bridge before she called you, the recording starts at the opening word — not from when you surfaced.",
    note: 'Recorded from minute one — not from when you woke up. By the time you bridge in, everything said before your arrival is already on the record. Nothing missing.',
  },
  {
    tag: 'Coming soon',
    title: 'Real-time bridge notes',
    body: "Silent live updates pushed to your screen as the meeting progresses — context, action items, decisions — without touching the host's controls or anyone else's experience.",
    note: null,
  },
  {
    tag: 'On the roadmap',
    title: 'Proxy attendance',
    body: "For meetings where your presence is expected but your input isn't immediately needed. Jessica holds the room, monitors for your name, and alerts you the moment it matters.",
    note: null,
  },
];

export default function DialBackRoadmap() {
  return (
    <section
      className="py-28 px-12 border-t border-white/[0.06] max-md:px-6 max-md:py-20"
      style={{ background: 'rgba(255,255,255,0.02)', fontFamily: "'Instrument Sans', sans-serif" }}
    >
      <div className="max-w-[1100px] mx-auto">
        <div
          className="flex items-center gap-3 mb-4"
          style={{ fontFamily: "'DM Mono', monospace", fontSize: '11px', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#c8472a' }}
        >
          <span className="block w-6 h-px bg-[#c8472a]" />
          What&apos;s coming
        </div>

        <h2
          className="font-light leading-[1.1] text-[#f5f2ec]"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}
        >
          The bridge is already yours —<br />
          <em className="italic text-[#9a9488]">here&apos;s what goes on top</em>
        </h2>

        <div className="grid grid-cols-2 gap-6 mt-14 max-md:grid-cols-1">
          {cards.map((card, i) => (
            <div
              key={i}
              className="p-7 border border-white/[0.07] rounded-[3px] bg-white/[0.01] transition-all duration-200 hover:border-white/[0.14] hover:bg-white/[0.03]"
            >
              <div
                className="mb-3 text-[#9a9488]"
                style={{ fontFamily: "'DM Mono', monospace", fontSize: '10px', letterSpacing: '0.14em', textTransform: 'uppercase' }}
              >
                {card.tag}
              </div>
              <div
                className="text-[#f5f2ec] mb-3 leading-[1.25]"
                style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: '1.3rem', fontWeight: 400 }}
              >
                {card.title}
              </div>
              <div className="text-[0.88rem] text-[rgba(245,242,236,0.6)] leading-[1.65]">
                {card.body}
              </div>
              {card.note && (
                <div className="mt-4 p-3 bg-[rgba(200,71,42,0.07)] border-l-2 border-[#c8472a] text-[0.82rem] text-[rgba(245,242,236,0.8)] leading-[1.5]">
                  <strong className="text-[#c8472a] font-medium">Recorded from minute one — not from when you woke up.</strong>{' '}
                  By the time you bridge in, everything said before your arrival is already on the record. Nothing missing.
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
